import styled from 'styled-components';

import { StyledLink } from 'ui/links';
import { fonts, fontSizes, spacing, textColors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const CampaignDetailsContainer = styled.ul`
  align-items: center;
  /** Temporary work-around until angular can be removed (which adds Proxima Nova to the body) */
  font-family: ${fonts.sansSerif};
  color: ${textColors.textSecondary};
  display: flex;
  gap: ${pxToRem(11)} ${spacing.half};
  flex-wrap: wrap;
  line-height: 1.15em;
  padding: 0;
`;

export const CampaignDetailsBlock = styled.li`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.s12};
  line-height: 1.15em;

  > svg {
    margin-right: ${spacing.half};
  }

  white-space: nowrap;
  &:not(:last-child):after {
    padding-left: ${spacing.half};
    content: '•';
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const CampaignDetailButtonLink = styled(StyledLink)`
  font-size: ${fontSizes.s12};
  line-height: 1.15em;
  border-bottom: unset;
  text-decoration: underline;
`;
